export default {"src":"/_next/static/media/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.e11c0fc6.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};